<template>
  <div id="Users">
    <MyBanner
      :text="$t('banner.accessDcPage')"
      v-if="$t('banner.accessDcPage') != ''"
    />
    <MyHeaderPage
      :title="$t('reports.paidInterventions.title')"
      :subtitle="$t('reports.paidInterventions.subTitle')"
    />
    <br /><br />
    <div id="TicketsList">
      <div class="listTicket">
        <!-- FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="filterTickets">
              <div class="contentInputFilter">
                <div class="contentIcon">
                  <span class="material-icons">search</span>
                </div>
                <div class="contentInput">
                  <input
                    type="text"
                    :placeholder="$t('actions.text_search_placeholder')"
                    v-model="searchString"
                    @keyup="searchByString"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateFrom"
                class="not-empty"
                v-model="dateFrom"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateFrom") }}</label>
              <span
                class="error"
                v-if="this.v$.dateFrom.$invalid && this.v$.dateFrom.$dirty"
              >
                {{ $t("reports.filter.dateFrom") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">
            <div class="cdl-input" style="margin-top: 0">
              <input
                type="date"
                name="dateTo"
                class="not-empty"
                v-model="dateTo"
                style="background-color: white"
                @change="getList()"
              />
              <label>{{ $t("reports.filter.dateTo") }}</label>
              <span
                class="error"
                v-if="this.v$.dateTo.$invalid && this.v$.dateTo.$dirty"
              >
                {{ $t("reports.filter.dateTo") }}
                {{ $t("reports.filter.isRequired") }}
              </span>
            </div>
          </div>
          <!-- CSV Export Button -->
          <div class="mdl-cell mdl-cell--3-col mdl-cell--12-col-phone">

            <ActionButton
                  custom-class="cdlButton"
                  :loading="isExporting"
                  :disabled="!viewLoader"
                  @click="exportCsv"
                >
              <img src="@/assets/img/download.png" alt="icon" />
              {{ $t("users.downLoadCSV") }}
            </ActionButton>
          </div>
        </div>
        <!-- FINE FILTRO -->
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <br />
            <ReportTable
              :items="itemFilter"
              :loading="viewLoader"
              :empty-colspan="$IsMobile() ? 1 : 9"
            >
              <template #header>
                <tr>
                  <th>{{ $t("reports.paidInterventions.col.colOne") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colTwo") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colThree") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colFour") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colFive") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colSix") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colSeven") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colEight") }}</th>
                  <th>{{ $t("reports.paidInterventions.col.colNine") }}</th>
                </tr>
              </template>

              <template #row="{ item, index }">
                <tr :class="{ odd: index % 2 }">
                  <td>
                    {{
                      $t("reports.paidInterventions.type." + item.ticket_url)
                    }}
                  </td>
                  <td>{{ item.ticket_esteso }}</td>
                  <td>{{ item.customer_ref }}</td>
                  <td>{{ item.data_apertura }}</td>
                  <td>
                    {{
                      item.po_number && item.po_number !== ""
                        ? item.po_number
                        : "-"
                    }}
                  </td>
                  <td>{{ item.doc_type }}</td>
                  <td>{{ item.doc_number }}</td>
                  <td>{{ item.date_total }}</td>
                  <td>
                    <strong v-if="item.type_price">
                      {{ $t("reports.paidInterventions." + item.type_price) }}:
                    </strong>
                    {{ item.total }}
                  </td>
                </tr>
              </template>

              <template #mobile="{ item, index }">
                <div :key="item.id || index" class="report-mobile-card">
                  <div>
                    <strong
                      >{{ $t("reports.paidInterventions.col.colOne") }}:</strong
                    >
                    {{
                      $t("reports.paidInterventions.type." + item.ticket_url)
                    }}
                  </div>
                  <div>
                    <strong
                      >{{ $t("reports.paidInterventions.col.colTwo") }}:</strong
                    >
                    {{ item.ticket_esteso }}
                  </div>
                  <div>
                    <strong
                      >{{
                        $t("reports.paidInterventions.col.colThree")
                      }}:</strong
                    >
                    {{ item.customer_ref }}
                  </div>
                  <div>
                    <strong
                      >{{
                        $t("reports.paidInterventions.col.colNine")
                      }}:</strong
                    >
                    <span v-if="item.type_price">
                      {{ $t("reports.paidInterventions." + item.type_price) }}:
                    </span>
                    {{ item.total }}
                  </div>
                  <div>
                    <strong
                      >{{
                        $t("reports.paidInterventions.col.colEight")
                      }}:</strong
                    >
                    {{ item.date_total }}
                  </div>
                </div>
              </template>
            </ReportTable>
            <!--            <div>-->
            <!--              <MyLoading :viewLoader="this.viewLoader" type="" />-->
            <!--            </div>-->
            <Paginator
              v-if="viewLoader && totalItems > 0"
              :total-page="paginatedItems"
              :current-page="currentPage"
              :itemsPerPage="itemsPerPage"
              @prev-page="beforePage"
              @next-page="nextPage"
              @change-page="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyBanner from "@/components/MyBanner.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import ReportTable from "@/components/Reports/ReportTable.vue";
import Paginator from "@/components/Paginator.vue";
import "@/assets/scss/TicketsList.scss";
import moment from "moment";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { exportCsvReport } from '@/services/CSVExportService.js'
import DownloadBinaryFile from '@/services/FileService'
import ActionButton from '@/components/Primitives/Buttons/ActionButton.vue'

export default {
  name: "CPaidInterventions",
  components: {
    MyBanner,
    MyHeaderPage,
    ReportTable,
    Paginator,
    ActionButton
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      dateFrom: { required },
      dateTo: { required },
    };
  },
  data() {
    return {
      viewLoader: false,
      items: [],
      itemFilter: [],
      // Add these for pagination
      currentPage: 1,
      itemsPerPage: 10,
      paginatedItems: 0,
      totalItems: 0,
      // For the CSV export
      isExporting: false,
      // items: [
      //   {
      //       "id": 240,
      //       "ticket_esteso": "2019122067000084",
      //       "customer_ref": "Davide De Luca",
      //       "data_apertura": "2019-12-20 16:17:38",
      //       "po_number": "",
      //       "ticket_url": "dc-remote-hands",
      //       "doc_type": "Fattura",
      //       "doc_number": "232",
      //       "total": "200,00",
      //       "type_price": null,
      //       "date_total": "2020-01-31"
      //   },
      //   {
      //       "id": 240,
      //       "ticket_esteso": "2019122067000084",
      //       "customer_ref": "Ciccio De Luca",
      //       "data_apertura": "2020-12-20 16:17:38",
      //       "po_number": "",
      //       "ticket_url": "dc-cross-connect",
      //       "doc_type": "Credito",
      //       "doc_number": "232",
      //       "total": "300,00",
      //       "type_price": null,
      //       "date_total": "2022-01-31"
      //   }
      // ],
      // itemFilter: [
      //   {
      //       "id": 240,
      //       "ticket_esteso": "2019122067000084",
      //       "customer_ref": "Davide De Luca",
      //       "data_apertura": "2019-12-20 16:17:38",
      //       "po_number": "",
      //       "ticket_url": "dc-remote-hands",
      //       "doc_type": "Fattura",
      //       "doc_number": "232",
      //       "total": "200,00",
      //       "type_price": null,
      //       "date_total": "2020-01-31"
      //   },
      //   {
      //       "id": 240,
      //       "ticket_esteso": "2019122067000084",
      //       "customer_ref": "Ciccio De Luca",
      //       "data_apertura": "2022-12-20 16:17:38",
      //       "po_number": "",
      //       "ticket_url": "dc-cross-connect",
      //       "doc_type": "Credito",
      //       "doc_number": "232",
      //       "total": "300,00",
      //       "type_price": null,
      //       "date_total": "2022-01-31"
      //   }
      // ],
      dateFrom: moment().subtract(6, "months").format("DD-MM-YYYY"),
      dateTo: moment().format("DD-MM-YYYY"),
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      lang: "en",
      searchString: "",
    };
  },
  methods: {
    async getList() {
      const result = await this.v$.$validate();
      if (result) {
        this.viewLoader = false;
        const self = this;

        let par = "";
        if (this.itemsPerPage) {
          par += "&per_page=" + this.itemsPerPage;
        }

        // Add search parameter if exists
        if (this.searchString && this.searchString.trim() !== "") {
          par += "&search=" + this.searchString;
        }

        this.axios
          .get(
            window.VUE_APP_MISTRA_URL +
              "front/v1/report-paid-support/?from=" +
              this.dateFrom +
              "&to=" +
              this.dateTo +
              "&page=" +
              this.currentPage +
              par,
            { headers: this.he }
          )
          .then((response) => {
            // Handle the pagination structure
            if (response.data.data) {
              // If the API returns paginated data
              this.items = response.data.data;
              this.currentPage = response.data.current_page || 1;
              this.itemsPerPage = response.data.per_page || 10;
              this.totalItems = response.data.total || this.items.length;
              this.paginatedItems = Math.ceil(
                this.totalItems / this.itemsPerPage
              );
            } else {
              // If the API returns a simple array
              this.items = response.data;
              this.totalItems = this.items.length;
              this.paginatedItems = 1;
            }

            this.itemFilter = this.items;
            this.viewLoader = true;
          })
          .catch(function (err) {
            self.viewLoader = true;
            console.log(err);
          });
      }
    },
    searchByString() {
      // Reset pagination when searching
      this.currentPage = 1;

      // If server-side search is implemented
      if (this.searchString.length >= 3 || this.searchString.length === 0) {
        this.getList();
      } else {
        // Client-side filtering as fallback
        this.itemFilter = [];
        let elm = this.searchString.toLowerCase();
        this.items.forEach((item) => {
          let ticket_url = item.ticket_url
            ? item.ticket_url.toLowerCase().includes(elm)
            : false;
          let ticket_esteso = item.ticket_esteso
            ? item.ticket_esteso.toLowerCase().includes(elm)
            : false;
          let customer_ref = item.customer_ref
            ? item.customer_ref.toLowerCase().includes(elm)
            : false;
          let data_apertura = item.data_apertura
            ? item.data_apertura.toLowerCase().includes(elm)
            : false;
          let po_number = item.po_number
            ? item.po_number.toLowerCase().includes(elm)
            : false;
          let doc_type = item.doc_type
            ? item.doc_type.toLowerCase().includes(elm)
            : false;
          let doc_number = item.doc_number
            ? item.doc_number.toLowerCase().includes(elm)
            : false;
          let date_total = item.date_total
            ? item.date_total.toLowerCase().includes(elm)
            : false;
          let type_price = item.type_price
            ? item.type_price.toLowerCase().includes(elm)
            : false;
          let total = item.total
            ? item.total.toLowerCase().includes(elm)
            : false;
          if (
            ticket_url ||
            ticket_esteso ||
            customer_ref ||
            data_apertura ||
            po_number ||
            doc_type ||
            doc_number ||
            date_total ||
            type_price ||
            total
          ) {
            this.itemFilter.push(item);
          }
        });
      }
    },
    // getPrice( item ) {
    //   let text = '';
    //   switch( type_price ) {
    //     case 'ATTIVAZIONE':
    //       text = "reports.paidInterventions."
    //   }
    // }

    // Methods to handle pagination for the Paginator component
    changePage(page) {
      this.currentPage = page;
      this.getList();
    },

    beforePage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getList();
      }
    },

    nextPage() {
      if (this.currentPage < Math.ceil(this.totalItems / this.itemsPerPage)) {
        this.currentPage++;
        this.getList();
      }
    },

    // Add this method for CSV export
    async exportCsv() {
      this.isExporting = true;
      const params = {
        from: this.dateFrom,
        to: this.dateTo,
        csv: true,
        ...(this.searchString?.trim() && { search: this.searchString })
      };

      try {
        const { blob, headers } = await exportCsvReport(
          window.VUE_APP_MISTRA_URL + "front/v1/report-paid-support/",
          this.$keycloak.idToken,
          params
        );
        const match = headers["content-disposition"]?.match(/filename="(.+)"/);
        const filename = match?.[1] ?? "paid_interventions_report.csv";
        DownloadBinaryFile.downloadBlob(blob, filename);
      } catch (error) {
        console.error(error);
      } finally {
        this.isExporting = false;
      }
    },
    /*exportCsv() {
      this.isExporting = true;

      // Create URL with all current filter parameters
      let par = "";
      if (this.searchString && this.searchString.trim() !== "") {
        par += "&search=" + this.searchString;
      }

      let header = {
        Authorization: "Bearer " + this.$keycloak.idToken,
        Accept: "text/csv",
      };

      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "front/v1/report-paid-support/?from=" +
            this.dateFrom +
            "&to=" +
            this.dateTo +
            "&csv=true" +
            par,
          { headers: header }
        )
        .then((response) => {
          // Create a blob URL and trigger download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Get filename from headers or use default
          const contentDisposition = response.headers["content-disposition"];
          let filename = "paid_interventions_report.csv";

          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="(.+)"/);
            if (filenameMatch && filenameMatch.length === 2) {
              filename = filenameMatch[1];
            }
          }

          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExporting = false;
        })
        .catch((error) => {
          console.error("Error downloading CSV:", error);
          this.isExporting = false;
        });
    },*/
  },
  computed: {
    pagedItems() {
      return this.items || [];
    },
    totalPages() {
      return Math.ceil(this.itemFilter.length / this.itemsPerPage);
    },
  },
  mounted() {
    this.getList();
    this.lang = this.$i18n.locale;
  },
};
</script>
